var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImageLayout',{staticClass:"changePasswordSuccess"},[_c('h2',[_vm._v("Password successfully updated")]),_c('p'),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }